import { BookOpen, Video, Download, WalletCards, GraduationCap, ClipboardList, Link2 } from "lucide-react";

// Publisher-style item types. `sources` drives the add/edit form's source picker.
export const ITEM_TYPES = [
  { value: "read", label: "Read", icon: BookOpen, sources: ["material", "url"] },
  { value: "watch", label: "Watch", icon: Video, sources: ["url", "material"] },
  { value: "ppt", label: "PowerPoints", icon: Download, sources: ["material", "url"] },
  { value: "flashcards", label: "Flashcards", icon: WalletCards, sources: [] },
  { value: "quiz", label: "Quiz / Exam", icon: GraduationCap, sources: ["exam"] },
  { value: "assignment", label: "Assignment / Project", icon: ClipboardList, sources: ["project"] },
  { value: "link", label: "Link", icon: Link2, sources: ["url"] },
];

export const GRADED_TYPES = ["quiz", "assignment"];

export const typeMeta = (t) => ITEM_TYPES.find((x) => x.value === t) || ITEM_TYPES[ITEM_TYPES.length - 1];

// YouTube / Vimeo URL -> embeddable URL (null when not embeddable)
export function embedUrl(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, "");
    if (host === "youtu.be") return `https://www.youtube.com/embed/${u.pathname.slice(1)}`;
    if (host === "youtube.com" || host === "m.youtube.com") {
      if (u.pathname === "/watch" && u.searchParams.get("v")) return `https://www.youtube.com/embed/${u.searchParams.get("v")}`;
      if (u.pathname.startsWith("/shorts/")) return `https://www.youtube.com/embed/${u.pathname.split("/")[2]}`;
      if (u.pathname.startsWith("/embed/")) return url;
    }
    if (host === "vimeo.com") {
      const id = u.pathname.split("/").filter(Boolean)[0];
      if (id && /^\d+$/.test(id)) return `https://player.vimeo.com/video/${id}`;
    }
    if (host === "player.vimeo.com") return url;
  } catch {
    return null;
  }
  return null;
}
